export default __webpack_public_path__ + "static/media/overnight2Disabled.6457ad3a.svg";